import api from "../../client";
export interface LoadFileResponse {
  data: {
    presignedUrl: string;
  };
}

export const loadFile = async (fileId: string): Promise<LoadFileResponse> => {
  const { data } = await api.get<LoadFileResponse>(`/file/${fileId}`);
  return data;
};
